import { Checkbox, Col, Form, Radio, Row, Typography } from 'antd';
import { useIntl } from 'react-intl';
import {
  DirectSaleXFinancialOrderType,
  DirectSaleXFinancialReportType,
} from '@/core/domain/questReport/Reports/DirectSaleXFinancial/DirectSaleXFinancial.types';

const FieldOrderOfReport: React.FC = () => {
  const intl = useIntl();
  const { Title } = Typography;

  return (
    <Col sm={24}>
      <Form.Item noStyle shouldUpdate>
        {({ getFieldValue }) => {
          const reportType = getFieldValue('reportType');

          return (
            <>
              {reportType ===
                DirectSaleXFinancialReportType.noFinancialOrDivergentValue && (
                <>
                  <Title level={5}>
                    {intl.formatMessage({
                      id: 'movementDirectSaleXFinancial.form.orderOfReport',
                    })}
                  </Title>

                  <Form.Item
                    name="orderType"
                    initialValue={
                      DirectSaleXFinancialOrderType.numberDirectSale
                    }
                  >
                    <Radio.Group
                      optionType="button"
                      buttonStyle="solid"
                      size="large"
                    >
                      <Radio
                        value={DirectSaleXFinancialOrderType.numberDirectSale}
                      >
                        {intl.formatMessage({
                          id: 'movementDirectSaleXFinancial.form.orderOfReport.numberDirectSale',
                        })}
                      </Radio>
                      <Radio value={DirectSaleXFinancialOrderType.employee}>
                        {intl.formatMessage({
                          id: 'movementDirectSaleXFinancial.form.orderOfReport.employee',
                        })}
                      </Radio>
                    </Radio.Group>
                  </Form.Item>

                  <Row>
                    <Col sm={24}>
                      <Form.Item
                        noStyle
                        name="onlyDirectSellWithNoFinancial"
                        initialValue={false}
                        valuePropName="checked"
                      >
                        <Checkbox>
                          {intl.formatMessage({
                            id: 'movementDirectSaleXFinancial.form.onlyDirectSaleWithoutFinancialRegistration',
                          })}
                        </Checkbox>
                      </Form.Item>
                    </Col>
                  </Row>
                </>
              )}
            </>
          );
        }}
      </Form.Item>
    </Col>
  );
};

export default FieldOrderOfReport;
